<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
              <div class="d-flex justify-content-between align-items-center flex-wrap px-3">
                <h6 class="text-white text-capitalize">(26년) 아동(학생) 반 편성</h6>
                <div class="d-flex align-items-center flex-wrap">
                  <select v-model="filters.department" @change="onDeptChange" class="form-select me-2 searchInput" style="width: fit-content; padding-left: 5px; padding-right: 15px;" >
                    <option value="">전체</option>
                    <option v-for="department in departments" :key="department.id" :value="department.id">
                      {{ department.name }}
                    </option>
                  </select>
                  <select v-model="filters.grade" @change="fetchList(1)" class="form-select me-2 searchInput" style="width: fit-content; padding-left: 5px; padding-right: 15px;">
                    <option value="">반</option>
                    <option v-for="g in grades" :key="g.grade" :value="g.grade">{{ g.gradename }}</option>
                  </select>
                  <input v-model="filters.name" type="text" class="form-control me-2 searchInput w-140" placeholder="이름 검색" />
                  <input v-model="filters.phone" type="text" class="form-control me-2 searchInput w-140" placeholder="연락처 검색" />
                  <select v-model="filters.useyn" @change="fetchList(1)" class="form-select me-2 searchInput" style="width: fit-content; padding-left: 5px; padding-right: 15px;">
                    <option value="">전체</option>
                    <option value="Y">활성</option>
                    <option value="N">비활성</option>
                  </select>
                  <button class="btn btn-light text-success ms-2" @click="fetchList(1)">검색</button>
                  <button v-if="false" class="btn btn-success ms-2" @click="openCreate">등록</button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body px-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table mb-0">
                <thead>
                  <tr class="text-center">
                    <th>번호</th>
                    <th>부서</th>
                    <th>반</th>
                    <th>사진</th>
                    <th>이름</th>
                    <th>생년월일</th>
                    <th>선생님</th>
                    <th>상태</th>
                    <th>최종 수정일</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="rows.length === 0">
                    <td colspan="9" class="text-center">자료가 없습니다</td>
                  </tr>
                  <tr v-for="(r, idx) in rows" :key="r.no" class="text-center">
                    <td>{{ (idx + 1) + ((currentPage - 1) * pageSize) }}</td>
                    <td>{{ r.class_name }}</td>
                    <td>{{ r.gradename }}</td>
                    <td><img :src="imageSrc(r)" class="avatar avatar-sm" alt="photo" /></td>
                    <td class="name" style="cursor:pointer; color:#0b62ff; font-weight:600;" @click="openEdit(r)">{{ r.name }}</td>
                    <td>{{ r.birthday }}</td>
                    <td>{{ r.teachername }}</td>
                    <td>{{ r.useyn_name }}</td>
                    <td>{{ r.updatedt }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-flex justify-content-center mt-4">
              <nav aria-label="Page navigation" v-if="totalPages > 0">
                <ul class="pagination">
                  <li class="page-item" :class="{ disabled: currentPage === 1 }">
                    <a class="page-link" href="#" @click.prevent="currentPage > 1 && fetchList(currentPage - 1)">&laquo;</a>
                  </li>
                  <li v-for="page in displayedPages" :key="page" class="page-item" :class="{ active: currentPage === page }">
                    <a class="page-link" href="#" @click.prevent="fetchList(page)">{{ page }}</a>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                    <a class="page-link" href="#" @click.prevent="currentPage < totalPages && fetchList(currentPage + 1)">&raquo;</a>
                  </li>
                </ul>
              </nav>
            </div>
            <div class="guide-box mt-3">
              <p class="mb-2">📢 <strong>아동(학생) 반 편성 안내</strong></p>
              <p class="mb-1">아동(학생)이 안보이는 경우 반드시 기존 타 부서에 있는지를 먼저 확인하시기 바랍니다.</p>
              <p class="mb-1">조회 조건을 <strong>전체</strong>로 설정한 후 이름 검색을 통해 타 부서에서 있는지를 확인합니다.</p>
              <p class="mb-2">기존에 등록된 정보가 있을 경우, 필요 시 부서를 수정하여 사용합니다.</p>
              <p class="mb-1"><strong>삭제 처리 안내</strong></p>
              <p class="mb-0">아동(학생) 정보는 삭제 처리하지 않으며, 더 이상 활동하지 않는 경우 상태를 “비활성”으로 변경하여 관리해 주시기 바랍니다.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div v-if="showModal" class="popup-overlay" @click.self="closeModal">
      <div class="popup-content">
        <h6 class="mb-3">{{ isCreate ? '등록' : '수정' }}</h6>
        <div class="row">
          <div class="col-md-6 mb-2">
            <label class="form-label">이름</label>
            <input class="form-control" v-model="form.name" :readonly="!isCreate" />
          </div>
          <div class="col-md-6 mb-2">
            <label class="form-label">생년월일</label>
            <input class="form-control" v-model="form.birthday" :readonly="true" />
          </div>
          <div class="col-md-6 mb-2">
            <label class="form-label">부서</label>
            <select class="form-select" v-model="form.classid" @change="onModalDeptChange">
              <option v-for="d in departments" :key="d.id" :value="d.id">{{ d.name }}</option>
            </select>
          </div>
          <div class="col-md-6 mb-2">
            <label class="form-label">반(grade)</label>
            <select class="form-select" v-model="form.grade" @change="syncGradename">
              <option v-for="g in modalGrades" :key="g.grade" :value="g.grade">{{ g.gradename }}</option>
            </select>
          </div>
          <div class="col-md-6 mb-2">
            <label class="form-label">반 이름(gradename)</label>
            <input class="form-control" v-model="form.gradename" :readonly="true" />
          </div>
          <div class="col-md-6 mb-2">
            <label class="form-label">선생님 선택</label>
            <select class="form-select" v-model="form.teacherid" @change="onTeacherChange">
              <option value="">선택</option>
              <option v-for="t in teacherOptions" :key="t.teacherid" :value="t.teacherid">{{ t.name }} ({{ t.teacherid }})</option>
            </select>
          </div>
          <div class="col-md-6 mb-2">
            <label class="form-label">선생님</label>
            <input class="form-control" v-model="form.teachername" :readonly="true" />
          </div>
          <div class="col-md-6 mb-2">
            <label class="form-label">상태</label>
            <select class="form-select" v-model="form.useyn">
              <option value="Y">활성</option>
              <option value="N">비활성</option>
            </select>
          </div>
        </div>
        <div class="text-end">
          <button class="btn btn-secondary me-2" @click="closeModal">취소</button>
          <button class="btn btn-success" @click="save">저장</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiservice from "@/services/apiservice";

export default {
  name: "StudentTempManage",
  data() {
    return {
      rows: [],
      departments: [],
      grades: [],
      modalGrades: [],
      filters: { department: '', grade: '', name: '', phone: '', useyn: '' },
      pageSize: 20,
      currentPage: 1,
      totalPages: 1,
      showModal: false,
      isCreate: false,
      form: { no: null, name: '', phone: '', birthday: '', classid: '', grade: '', gradename: '', teacherid: '', teachername: '', useyn: 'Y' },
      teacherOptions: []
    };
  },
  computed: {
    isSuperUser() { return this.$store.state.userData?.superuser === '1'; },
    displayedPages() {
      const pages = [];
      const max = 5;
      if (this.totalPages <= max) { for (let i=1;i<=this.totalPages;i++) pages.push(i); }
      else {
        let start = Math.max(1, this.currentPage - Math.floor(max/2));
        let end = start + max - 1;
        if (end > this.totalPages) { end = this.totalPages; start = Math.max(1, end-max+1); }
        for (let i=start;i<=end;i++) pages.push(i);
      }
      return pages;
    }
  },
  methods: {
    imageSrc(r) {
      if (r.photo) return `https://manna.dongan1718.com/upload/photo/${r.photo}`;
      if (r.photo2) return `https://manna.dongan1718.com/upload/photo/${r.photo2}`;
      return require('@/assets/img/noimage.png');
    },
    async fetchDepartments() {
      const res = await apiservice.getdeptlist();
      this.departments = res.data.data.map(d => ({ id: d.code, name: d.codename }));
    },
    async onDeptChange() {
      if (!this.filters.department) { this.grades = []; /* 최초엔 자동 조회하지 않음 */ return; }
      const res = await apiservice.get_temp_classlist({ classid: this.filters.department });
      this.grades = res.data.data || [];
      // 자동 조회하지 않음; 사용자가 검색 버튼으로 조회
    },
    async onModalDeptChange() {
      if (!this.form.classid) { this.modalGrades = []; return; }
      const res = await apiservice.get_temp_classlist({ classid: this.form.classid });
      this.modalGrades = res.data.data || [];
      if (!this.modalGrades.find(g => g.grade === this.form.grade)) this.form.grade = '';
      await this.fetchTeachers();
    },
    syncGradename() {
      const found = this.modalGrades.find(g => g.grade === this.form.grade);
      if (found) this.form.gradename = found.gradename;
    },
    async fetchTeachers() {
      if (!this.form.classid) { this.teacherOptions = []; return; }
      try {
        const res = await apiservice.get_temp_teachers({ classid: this.form.classid });
        this.teacherOptions = res.data.data || [];
        const matched = this.teacherOptions.find(t => t.teacherid === this.form.teacherid);
        if (!matched) { this.form.teacherid = ''; this.form.teachername = ''; }
        else { this.form.teachername = matched.name; }
      } catch (e) { this.teacherOptions = []; }
    },
    onTeacherChange() {
      const matched = this.teacherOptions.find(t => t.teacherid === this.form.teacherid);
      this.form.teachername = matched ? matched.name : '';
    },
    async fetchList(page=1) {
      const params = { page, limit: this.pageSize, department: this.filters.department, grade: this.filters.grade, name: this.filters.name, phone: this.filters.phone, useyn: this.filters.useyn };
      const res = await apiservice.studenttemp_list({ params });
      this.rows = res.data.data || [];
      this.currentPage = parseInt(res.data.currentPage || 1);
      this.totalPages = parseInt(res.data.totalPages || 1);
    },
    openEdit(r) {
      this.isCreate = false;
      this.form = { ...r, no: r.no, classid: r.classid, grade: r.grade, gradename: r.gradename, teacherid: r.teacherid, teachername: r.teachername, birthday: r.birthday, useyn: r.useyn };
      this.showModal = true;
      this.onModalDeptChange();
      this.fetchTeachers();
    },
    openCreate() {
      this.isCreate = true;
      const defaultDept = this.isSuperUser ? '' : (this.$store.state.userData?.classid || '');
      this.form = { no: null, name: '', phone: '', birthday: '', classid: defaultDept, grade: '', gradename: '', teacherid: '', teachername: '', useyn: 'Y' };
      this.showModal = true;
      this.onModalDeptChange();
      this.fetchTeachers();
    },
    closeModal() { this.showModal = false; },
    async save() {
      try {
        if (this.isCreate) await apiservice.studenttemp_create(this.form);
        else await apiservice.studenttemp_update(this.form);
        this.showModal = false;
        this.fetchList(this.currentPage);
      } catch (e) { alert('저장 중 오류'); }
    },
    async remove() {
      if (!confirm('삭제하시겠습니까?')) return;
      try { await apiservice.studenttemp_delete({ no: this.form.no }); this.showModal=false; this.fetchList(this.currentPage); }
      catch(e){ alert('삭제 중 오류'); }
    }
  },
  async mounted() {
    await this.fetchDepartments();
    const user = this.$store.state.userData;
    if (user && user.superuser !== '1') this.filters.department = user.classid;
    // 최초에는 리스트를 자동 조회하지 않음
  }
};
</script>

<style scoped>
.searchInput { text-align: center; background-color: white !important; margin-bottom: 0; }
.w-140 { width: 140px; min-width: 140px; }
.avatar-sm { width: 40px; height: 40px; }
.popup-overlay { position: fixed; inset: 0; background: rgba(0,0,0,.4); display:flex; align-items:center; justify-content:center; z-index: 1050; }
.popup-content { background:#fff; border-radius:8px; padding:16px; width:720px; max-width:95vw; border: 1px solid #dee2e6; }
.form-control, .form-select { border: 1px solid #ced4da !important; box-shadow: none !important; }
.btn { margin-bottom: 0 !important; }
/* 안내 박스 */
.guide-box {
  background: #f8f9fa;
  border: 1px solid #e0e6ed;
  border-radius: 8px;
  padding: 12px 16px;
  color: #344767;
  font-size: 0.925rem;
  line-height: 1.5;
}
@media (max-width: 768px) {
  .d-flex { flex-direction: column; align-items: stretch; }
  .form-select, .form-control { width: 100% !important; margin-bottom: 10px; }
  .searchInput { text-align: left; }
}
</style>


